var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar",class:{ 'sidebar-transparent': _vm.pageOptions.pageSidebarTransparent },attrs:{"id":"sidebar"}},[_c('vue-scroll',{attrs:{"ops":_vm.ops}},[_c('sidebar-nav-profile'),_vm._v(" "),_c('sidebar-nav')],1)],1),_vm._v(" "),_c('div',{staticClass:"sidebar-bg"}),_vm._v(" "),_c('div',{staticClass:"mobile-click",on:{"click":_vm.dismissSidebar}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/sidebar/Sidebar.vue?vue&type=template&id=874dd30a&
// module id = null
// module chunks = 